angular.module('unergie.main')
.controller('activationsCtrl', ($scope, $state, AccountService, AlertManager, DataAccess, FilterMapping, TableGeneratorService,
    AdminComments, ReferencesService, BoFeaturesService, AuthService, ErrorCatcher) => {
    $scope.canChooseIdGrdContract = BoFeaturesService.isFeatureOn('canChooseIdGrdContract')
    const affectableFiltered = BoFeaturesService.get('filterForContractAffectation').split(',')
    const crossOrg = BoFeaturesService.isFeatureOn('crossOrg')
    $scope.canEscalate = BoFeaturesService.isFeatureOn('canEscalate')
    $scope.canSelfAffect = BoFeaturesService.isFeatureOn('canSelfAffect')
    $scope.canMarkLost = BoFeaturesService.isFeatureOn('canMarkLost')
    $scope.contract_status_mapping = FilterMapping.contractStatus

    $scope.ouinon = [{ id: true, title: 'Oui' }, { id: false, title: 'Non' }]

    $scope.activations = {
        refreshing: false,
        show: {},
        columns: {
            'id': { label: 'Id', mode: 'search_wildcard', length: 9 },
            'account.fullname': { label: 'Nom', mode: 'search_wildcard' },
            'account.category': { label: 'Type de compte', mode: 'hidden' },
            'provider_offer': { label: `Offre`, mode: 'search_wildcard', isVisible: false },
            'channel': { label: `Canal`, mode: 'search_wildcard', isVisible: false },
            'status': { label: 'Statut', mode: 'search_operator' },
            'activation_status': { label: 'Statut activation', mode: 'search_wildcard' },
            'id_prm': { label: 'PRM', mode: 'search_wildcard', length: 14 },
            'creation_ts': { label: 'Date souscription', mode: 'search_date' },
            'distributor_request_date': { label: 'Date de demande', mode: 'search_date' },
            'intervention_date': { label: 'Date intervention', mode: 'search_date' },
            'nb_actions': { label: 'Etape', mode: 'search_operator' },
            'last_action_date': { label: 'Date dernière étape', mode: 'search_date' },
            'overdue_check': { label: 'Doute', mode: 'search_strict' },
            'subscription_type': { label: 'Type souscription', mode: 'search_wildcard' },
            'affectation_user': { label: 'Affectation', mode: 'search_wildcard' },
            'termination_request_date': { label: 'Demande résiliation', mode: 'search_wildcard' },
            'affected_id': { label: `Id de l'affecté`, mode: 'hidden' },
            'affectation_id': { label: `Id de l'affectation`, mode: 'hidden' },
        },
    }

    if (crossOrg) {
        $scope.activations.columns.contract_org = { label: `Organisation`, mode: 'search_wildcard' }
    } else {
        $scope.activations.show.contract_org = false
    }

    $scope.refresh = () => TableGeneratorService.getTable(
        $scope.activations,
        'contracts-needing-attention',
        undefined,
        undefined,
        {
            search: {
                id_grd_contract: $scope.grdContracts.chosen,
            },
        }
    )

    $scope.grdContracts = {
        ids: [],
        chosen: undefined,
    }

    ReferencesService.getRef('id-grd-contracts', true).then((mapping) => {
        $scope.grdContracts.ids = _.map(mapping, 'id')
        $scope.grdContracts.chosen = $scope.grdContracts.ids[0]
        $scope.refresh()
    })

    ReferencesService.getRef('contractStatus').then((contractStatusMapping) => {
        const filteredContractStatusMapping = angular.fromJson(angular.toJson(contractStatusMapping))
        $scope.contractMapping = _.map(filteredContractStatusMapping, (value, key) => ({ id: key, label: _.get(value, '[0].label_fr', key) }))
    })

    $scope.isActive = (state) =>
        $state.is(state)

    $scope.isLateRequest = (contractElec) =>
        moment(contractElec.distributor_request_date).isBefore(moment().add(-48, 'hours'))

    $scope.isLateInter = (contractElec) =>
        moment(contractElec.intervention_date).isBefore(moment().add(-24, 'hours'))

    $scope.isLateSub = (contractElec) =>
        (contractElec.status === 0) && moment(contractElec.creation_ts).isBefore(moment().add(-24, 'hours'))

    $scope.isLateTermination = (contractElec) =>
        (moment(contractElec.termination_request_date).isBefore(moment().add(-5, 'days')) && contractElec.status !== 14) ||
        (moment(contractElec.termination_request_date).isBefore(moment().add(-10, 'days')) && contractElec.status !== 4)

    // AFFECTATION
    $scope.escalationFields = {
        escalationId: {
            label: 'Utilisateur',
            required: true,
            type: 'select',
            enum: [],
        },
        comment: {
            label: 'Raison',
            required: true,
            type: 'text',
        },
    }

    $scope.rawUserList = []
    let rawEscList = []

    let orgToFetch

    if (AuthService.getAuth().organization !== BoFeaturesService.get('provider')) {
        orgToFetch = `${BoFeaturesService.get('provider')},${AuthService.getAuth().organization}`
    }

    $scope.userFilter = {
        givenname: undefined,
        sn: undefined,
        organization: undefined,
        groups: undefined,
    }

    const refreshUsers = () => {
        DataAccess.users({ org: orgToFetch }).$promise.then((data) => {
            $scope.rawUserList = _.filter(data, (d) => affectableFiltered.indexOf(d.groups) >= 0)
            _.forEach($scope.rawUserList, (d) => {
                let label = `${d.givenname} ${d.sn}`
                if (d.groups) {
                    if (crossOrg) {
                        label += ` (${d.organization} - ${d.groups})`
                    } else {
                        label += ` (${d.groups})`
                    }
                }
                d.label = label
            })
        })
        if ($scope.canEscalate) {
            DataAccess.getEscalationList().$promise.then((data) => {
                rawEscList = data
                const escList = []
                _.forEach(data, (d) => {
                    const label = `${d.givenname} ${d.sn}`
                    escList.push({ value: d.id, label })
                })
                $scope.escalationFields.escalationId.enum = _.orderBy(escList, 'label')
            })
        }
    }

    refreshUsers()

    $scope.affect = (contractElec) => {
        const mail = __guard__(_.find($scope.rawUserList, { id: contractElec.affected_id }), (x) => x.mail)
        DataAccess.affectContract({ id_contract: contractElec.id, id_account: contractElec.affected_id, affectation_purpose: 'ACTIVATION', mail }).$promise.then((result) => {
            AlertManager.success('Contrat affecté')
            $scope.refresh()
        }).catch(ErrorCatcher)
    }

    $scope.escalate = function (contractElec) {
        const mail = __guard__(_.find(rawEscList, { id: contractElec.escalationId }), (x) => x.mail)
        AdminComments.addComment({ object: contractElec.id, comment: contractElec.comment }).$promise.catch(ErrorCatcher)
        DataAccess.affectContract({ id_contract: contractElec.id, id_account: contractElec.escalationId, affectation_purpose: 'ACTIVATION', mail }).$promise.then((result) => {
            AlertManager.success('Contrat remonté à l’escalade')
            $scope.refresh()
        }).catch(ErrorCatcher)
    }

    $scope.assignToUser = (contractElec) => {
        DataAccess.affectContract({ id_contract: contractElec.id, id_account: AuthService.getAuth().accountId, affectation_purpose: 'ACTIVATION' }).$promise.then((result) => {
            AlertManager.success('Contrat affecté')
            $scope.refresh()
        }).catch(ErrorCatcher)
    }

    // ACTIONS
    $scope.actionFields = {
        action: {
            label: 'Action',
            required: true,
            type: 'select',
            enum: [
                { label: 'Client contacté - message', value: 'client_contact_msg' },
                { label: 'Client contacté - KO', value: 'client_contact_ko' },
                { label: 'Enedis Contacté - msg', value: 'client_enedis_msg' },
                { label: 'Enedis Contacté - KO', value: 'client_enedis_ko' },
            ],
        },
    }

    // <NOT IN USE> (for now)
    $scope.actionPayload = {
        action: 'client_contact_ok',
    }

    const logForContract = (contractElec, msg) => {
        AdminComments.addComment({ object: contractElec.id, comment: msg }).$promise.catch(ErrorCatcher)
    }

    // const actions = {
    //     client_contact_msg(contractElec) {
    //         logForContract(contractElec, 'ACTIVATION:<br> Le client a été contacté sans succès, un message a été laissé.')
    //     },
    //     // Send EMAIL + SMS
    //     client_contact_ko(contractElec) {
    //         logForContract(contractElec, 'ACTIVATION:<br> Le client a été contacté, mais ne désire plus poursuivre sa commande.')
    //     },
    //     client_enedis_msg(contractElec) {
    //         logForContract(contractElec, 'ACTIVATION:<br> Enedis a été contacté sans succès, un message a été laissé.')
    //     },
    //     client_enedis_ko(contractElec) {
    //         logForContract(contractElec, 'ACTIVATION:<br> Enedis a été contacté, une indisponibilité demande de rélancer la demande plus tard.')
    //     },
    // }
    // </NOT IN USE> (for now)

    $scope.commentPayload = {
        comment: '',
    }

    $scope.commentFields = {
        comment: {
            label: 'Commentaire (optionnel)',
            type: 'text',
        },
    }

    $scope.initComment = () => {
        $scope.commentPayload.comment = ''
    }

    $scope.takeAction = (contractElec) => {
        if ($scope.commentPayload.comment) {
            if (!_.isEmpty($scope.commentPayload.comment)) {
                logForContract(contractElec, `[suivi des activations] : ${$scope.commentPayload.comment}`)
            }
            logForContract(contractElec, '<b>AUTOMATIQUE</b> [suivi des activations] : action réalisée, en attente de 7 jours supplémentaires')
        }
        if (contractElec.affected_id) {
            DataAccess.takeActionOnAffectation({ id: contractElec.affectation_id }, { action: $scope.actionPayload.action }).$promise.then(() => {
                AlertManager.success('Action logguée')
                $scope.refresh()
            }).catch(ErrorCatcher)
        } else {
            AlertManager.error('Pas encore affecté')
        }
    }

    $scope.contractLost = (contractElec) =>
        DataAccess.markContractLost({ id_contract: contractElec.id }, {}).$promise.then(() => {
            AlertManager.success('Action effectuée')
            AdminComments.addComment({ object: contractElec.id, comment: '<b>AUTOMATIQUE</b> [suivi des activations] : affaire marquée comme perdue' }).$promise.catch(ErrorCatcher)
            $scope.refresh()
        }).catch(ErrorCatcher)
})

function __guard__(value, transform) {
    return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined
}
